export default __webpack_public_path__ + "static/media/6t.a802de00.jpg";